export const FAX_ORDER_FORM_LINK =
  'https://static.shop-apotheke.com/media/pdf/fax_bestellschein.pdf'
export const FAX_ORDER_FORM_LINK_EUROPA_APOTHEEK =
  'https://static.shop-apotheke.com/media/content/service/europa_apotheek-bestellschein.pdf'
export const APOTHEEK_ORDER_FORM_LINK =
  'https://static.shop-apotheke.com/media/content/service/europa_apotheek-bestellschein.pdf'
export const FREE_ENVELOPE_LINK =
  'https://static.shop-apotheke.com/media/pdf/freiumschlag.pdf'
export const FREE_ENVELOPE_LINK_EUROPA_APOTHEEK =
  'https://static.shop-apotheke.com/media/pdf/Freiumschlag-EAV.pdf'
export const SPENDE_FLYER_PDF =
  'https://static.shop-apotheke.com/media/content/service/SHOP_APOTHEKE-Spendenflyer_Herzenswuensche.pdf'
export const PRIVATE_RECIPE_BONUS_PDF =
  'https://static.shop-apotheke.com/media/pdf/SHOP_APOTHEKE-Privatrezept_Bonus.pdf'
